module.exports = __webpack_public_path__ + "static/img/1-1Z6041421345N.d7703e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z6041421345N.jpg
// module id = lVR5
// module chunks = 0